import React from "react";
import ShoppingListItem from "./ShoppingListItem";
import {setItemTick} from "../service.js";
import {mergeIngredients} from "../dedupe.js";


export default function StockList({
    mealsFromServer,
    updateMealsFromServer,
  }){

  //dedupe in-scope meal ingredients into the stock list (shared with the shopping list)
  let ingredientList = mergeIngredients(mealsFromServer)

  function handleTick(i){
      console.log(i)
      updateMealsFromServer(prevMealList => {
        const meals_with_ingredient = ingredientList[i].fromMeal.map((mealWithIngredient) => mealWithIngredient.id)
        const newMealList = prevMealList.map((meal)=> {
          if(meals_with_ingredient.includes(meal.id)){
            return {...meal, ingredients: meal.ingredients.map((ingredient) => ingredient.label === ingredientList[i].label ? {...ingredient,ticked:!ingredientList[i].ticked}:ingredient)}
          }
          else{
            return meal
          }
          }
        )
  
        //toggle tick status
        setItemTick(ingredientList[i].fromMeal[0].id,ingredientList[i].id,!ingredientList[i].ticked)
        return newMealList
      })
    }

  return (
    <div className="list">
      <h4 className="category--name">
      Check stock of:
      </h4>
      <div className="category--list">
        {
          ingredientList.map(
            (li,i) => (!li.ticked && li.stocked) ?
            <ShoppingListItem key={i}
            handleTick={handleTick}
            originalIndex={i}
            checked={false}
            label={li.label}
            fromMeal={li.fromMeal}
            justMade={i===0 && li.label === "new"}
            /> : null
          )
        }
      </div>
    </div>
  )
}